// @owners { team: patients }
import boxRotated from './altoBox.png';
import logo from './altoLogo.png';
import autoRefill from './autoRefill.png';
import bagWithMedications from './bagWithMedications.png';
import bikeCourierWithBackground from './bikeCourierGreenBackground.png';
import box from './box.png';
import calendarAngled from './calendar-angled.png';
import calendar from './calendar.png';
import cashPrice from './cashPrice.png';
import delivery from './delivery.png';
import deliveryCheckmark from './deliveryCheckmark.png';
import deliveryCourierWithPatient from './delivery_patient_and_courier_circle.png';
import deliveryWoman from './delivery_woman.png';
import fertilityPackageDelivered from './fertility_package_checkmark.png';
import bikeCourier from './freeDelivery.png';
import gear from './gear.gif';
import helpBubble from './helpBubble.png';
import helpBubbleTransparent from './help_bubble_transparent.png';
import icePacks from './ice-packs.png';
import injectionVideo from './injection_video.png';
import mail from './mail.png';
import onboardingWelcome from './onboardingWelcome.png';
import pharmacistCheckmark from './pharmacist_checkmark.png';
import pickup from './pickup.png';
import pillBottle from './pillBottle.png';
import prescription from './prescription.png';
import prescriptionNoBackground from './prescriptionNoBackground.png';
import progynyWelcome from './progynyWelcome.png';
import syringe from './syringe-vials.png';
import wallet from './wallet.png';

export const images = {
  autoRefill,
  bagWithMedications,
  bikeCourier,
  bikeCourierWithBackground,
  box,
  boxRotated,
  calendar,
  calendarAngled,
  cashPrice,
  delivery,
  deliveryCheckmark,
  deliveryCourierWithPatient,
  deliveryWoman,
  fertilityPackageDelivered,
  gear,
  helpBubble,
  helpBubbleTransparent,
  icePacks,
  injectionVideo,
  logo,
  logoFooter: logo,
  mail,
  onboardingWelcome,
  pharmacistCheckmark,
  pickup,
  pillBottle,
  prescription,
  prescriptionNoBackground,
  progynyWelcome,
  syringe,
  wallet,
};

export type Images = typeof images;
